const statusColors: Record<string, string> = {
  "Ativa": "bg-primary-100 text-primary-700",
  "Em revisão": "bg-warning-100 text-warning-700",
  "Pendente de documentação": "bg-warning-50 text-warning-600",
  "Inativa": "bg-background-100 text-foreground-500",
  "Bloqueada": "bg-danger-100 text-danger-700",
  "Arquivada": "bg-background-200 text-foreground-400",
};

interface PartyStatusBadgeProps {
  status: string;
}

export default function PartyStatusBadge({ status }: PartyStatusBadgeProps) {
  const colors = statusColors[status] || "bg-background-100 text-foreground-500";
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${colors}`}>
      {status}
    </span>
  );
}